import { useContext } from "react";
import { CategoryContext } from "./CategoryContext";

export default function useCategory() {
  return useContext(CategoryContext);
}
